import './contacto.css';

const Contacto = () => {

    return(
        <div>
            Formulario de contacto
        </div>
    );
}

export default Contacto;